"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnchorsDefinition = void 0;
const services_definitions_1 = require("@wix/services-definitions");
exports.AnchorsDefinition = (0, services_definitions_1.defineService)('viewer-core/viewer-service-anchors');
//# sourceMappingURL=index.js.map